export default input => input.split('base64,')[1];
